//
// GENERATED by KVision
//
package pl.finn.forms.wouip

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.wouip.WouipForm
import pl.finn.forms.wouip.WouipFormData

actual class WouipService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : IWouipService, KVRemoteAgent<WouipService>(WouipServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(IWouipService::nowy, token)
    override suspend fun edycja(token: String) = call(IWouipService::edycja, token)
    override suspend fun sprawdz(wouipForm: WouipForm, zalaczniki: List<Zalacznik>, token: String) = call(IWouipService::sprawdz, wouipForm, zalaczniki, token)
    override suspend fun zapisz(wouipForm: WouipForm, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(IWouipService::zapisz, wouipForm, zalaczniki, validateResult, token)
    override suspend fun podglad(wouipForm: WouipForm, zalaczniki: List<Zalacznik>, token: String) = call(IWouipService::podglad, wouipForm, zalaczniki, token)
}
